import { BoardPageAppearance } from './mobileSettingsConstants';

export const getMobileBoardAppearanceSetting = (state: any): BoardPageAppearance =>
    state.getIn(['local', 'mobile']).settings.boardPageAppearance;
